<div class="profile-container">
  <h2 class="profile-title">Mi Perfil</h2>
  <p class="section-description">Phoenix Dashboard / Perfil</p>

  
  <!-- Sección de perfil -->
  <section class="section-header-container">
    <h2 class="section-title">Mi cuenta</h2>
    <div class="profile-main-card">
      <!-- Card de la foto de perfil -->
      <div class="profile-photo-card">
        <img [src]="getProfilePhotoUrl()" (error)="onPhotoError($event)" alt="Foto de perfil" class="profile-photo">
      </div>
      
      <!-- Card de información personal -->
      <div class="profile-info-card">
        <div class="card-header">
          <h3 class="card-title">Información Personal</h3>
          <!-- <button type="button" class="edit-button" (click)="editProfile()">
            <i class="fa-solid fa-pencil"></i>
          </button> -->
        </div>
        
        <div class="info-grid">
          <div class="info-item">|
            <span class="label">Nombre</span>
            <span class="value">{{ user.firstName || (user.name ? user.name.split(' ')[0] : '') || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Apellidos</span>
            <span class="value">{{ user.lastName || (user.name ? user.name.split(' ').slice(1).join(' ') : '') || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Correo electrónico</span>
            <span class="value">{{ user.email }}</span>
          </div>
          <div class="info-item">
            <span class="label">Número de teléfono</span>
            <span class="value">+{{ user.codePhone || '51' }} {{ user.phone || getValue('phone') }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!-- Sección de cuenta -->
  <!-- <section class="section-container" (click)="toggleSection(0)">
    <div class="section-left">
      <div class="section-header-res">
        <h2 class="section-title">Cuenta</h2>
        <i class="fa-solid" *ngIf="isResponsive" [ngClass]="sectionsState[0] === 'expanded' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </div>
      <p *ngIf="sectionsState[0] === 'expanded'" class="section-description">Información de cuenta.</p>
    </div>
    <div class="section-right" [@expandCollapse]="sectionsState[0]">
      <div class="form-group">
        <label>Celular</label>
        <p class="field-value">{{ getValue('phone') }}</p>
      </div>
      <div class="form-group">
        <label>Correo electrónico</label>
        <p class="field-value">{{ user.email }}</p>
      </div>
    </div>
  </section> -->

  <!-- Sección personal -->
  <section class="section-container">
    <div class="section-header">
      <h2 class="section-title">Información personal</h2>
      <!-- <button type="button" class="edit-button" (click)="editProfile()">
        <i class="fa-solid fa-pencil"></i>
      </button> -->
    </div>
    
    <div class="section-content">
      <div class="info-item">
        <span class="label">¿Sigues vinculado al mundo laboral?</span>
        <span class="value">{{ user.personalSection?.hobbys || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="label">¿Te gustaría participar en comunidades?</span>
        <span class="value">{{ user.personalSection?.colors || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="label">¿En qué tipo de comunidades te interesaría participar?</span>
        <span class="value">{{ user.personalSection?.travelDestination || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="label">¿Qué tipo de interacciones prefieres?</span>
        <span class="value">{{ getValue('personalSection.newActivities') || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="label">¿Qué esperas encontrar en una comunidad como Phoenix?</span>
        <span class="value">{{ getValue('personalSection.newActivities') || '-' }}</span>
      </div>
    </div>
  </section>

  <!-- Sección profesional -->
  <section class="section-container">
    <div class="section-header">
      <h2 class="section-title">Información profesional</h2>
      <!-- <button type="button" class="edit-button" (click)="editProfile()">
        <i class="fa-solid fa-pencil"></i>
      </button> -->
    </div>
    
    <div class="section-content">
      <div class="info-item">
        <span class="label">¿Sigues vinculado al mundo laboral?</span>
        <span class="value">{{ getDisabledSectProfessional() ? 'Sí' : 'No' }}</span>
      </div>
      <div class="info-item" *ngIf="getDisabledSectProfessional()">
        <span class="label">¿En qué industria o sector trabajas?</span>
        <span class="value">{{ user.professionalSection?.professionalData?.company || '-' }}</span>
      </div>
      <div class="info-item" *ngIf="getDisabledSectProfessional()">
        <span class="label">¿Qué puesto desempeñas actualmente?</span>
        <span class="value">{{ user.professionalSection?.professionalData?.job || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="label">¿Qué habilidades o áreas profesionales te interesan desarrollar?</span>
        <span class="value">{{ user.professionalSection?.skills || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="label">¿Tienes interés en emprender o colaborar en proyectos nuevos?</span>
        <span class="value">{{ user.professionalSection?.futureProjects || '-' }}</span>
      </div>
    </div>
  </section>
  <div class="button-edit">
    <button (click)="editProfile()" class="boton-principal">Editar perfil</button>
  </div>
</div>
